import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import SearchTable from 'src/components/searchTable'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import { checkPermissions, raiseToast } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import { PERMISSIONS } from 'src/views/utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import { EMAIL_TEMPLATE_API } from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'

const EmailTemplate = () => {
  const [emailsList, setEmailsList] = useState([])
  const { setLoader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const history = useHistory()

  const isCreateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.EMAIL_TEMPLATE.CREATE,
  )
  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.EMAIL_TEMPLATE.UPDATE,
  )

  const [{ data: emailList, loading: emailListLoading }, emailListCall] = useAxios(
    {
      url: EMAIL_TEMPLATE_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: updateTemplate, loading: updateTemplateLoading }, templateUpdateCall] = useAxios(
    {
      url: EMAIL_TEMPLATE_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(emailListLoading || updateTemplateLoading)
  }, [updateTemplateLoading])

  useEffect(() => {
    emailListCall()
    console.log(emailList)
  }, [])

  useEffect(() => {
    if (updateTemplate && updateTemplate.success) {
      emailListCall()
      raiseToast('success', 'Template Status updated successfully')
    }
  }, [updateTemplate])

  useEffect(() => {
    if (emailList && emailList.success) {
      setEmailsList(emailList.data.filter((item) => item.is_system_defined))
    }
  }, [emailList])

  const handleStatus = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    editTemplate({ status: !info.status }, info._id)
  }

  const editTemplate = (payload, id) => {
    templateUpdateCall({
      params: {
        email_template_id: id,
      },
      data: payload,
    })
  }

  const newTemplate = () => {
    history.push({
      pathname: '/email-template-edit',
    })
  }

  const handleEdit = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    const param = 'email_template_id=' + info._id
    history.push(`/email-template-edit?${param}`)
  }
  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 22,
    },
    {
      header: 'Type',
      dataCell: (info) => info.template_type,
      width: 33,
    },
    {
      header: 'Description',
      dataCell: (info) => info.subject,
      width: 33,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 15,
    },
    {
      header: 'Status',
      dataCell: (info) => {
        const disableTemplates = []
        return (
          <CFormSwitch
            label={info.status ? 'Active' : 'Disabled'}
            checked={info.status}
            valid={info.status}
            value={info.status}
            onChange={() => handleStatus(info)}
            size="lg"
            disabled={disableTemplates.includes(info.name) && info?.is_system_defined}
          />
        )
      },
      width: 16,
    },
    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => {
        return (
          <CIcon
            icon={cilPencil}
            style={{ cursor: `pointer` }}
            size="lg"
            title="Edit"
            onClick={() => handleEdit(info)}
          />
        )
      },
      width: 9,
    },
  ]
  return (
    <>
      <div className="mt-2">
        <h4>Email Templates</h4>
        <p>{`Manage your Email Templates`}</p>
        <SearchTable
          type={`Email Templates`}
          tableCardHeight={65}
          disableButton={true}
          buttonName={`+ Add New Template`}
          buttonFunction={newTemplate}
          searchTerm={`name`}
          tableContent={emailsList}
          tableConfig={tableConfig}
          createPermission={isCreateAllowed}
        />
      </div>
    </>
  )
}

export default EmailTemplate
